module.exports = __webpack_public_path__ + "static/img/head.02aae59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/head.png
// module id = HICh
// module chunks = 216